module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "templateDesigner group p-20"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInDown",
      "leave-active-class": "animated fadeOutUp"
    }
  }, [(!_vm.showFullService) ? _c('div', {
    staticClass: "design-options p-10 p-b-0 m-b-20 primarybg"
  }, [_c('a', {
    staticClass: "btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-angle-left m-r-5 primarytext"
  }), _vm._v(" Back to Designer")]), _vm._v(" "), (_vm.$auth.user().vendor) ? _c('button', {
    staticClass: "btn btn-outline-success solid m-b-10 right animated pulse primaryborder m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadFiles()
      }
    }
  }, [_vm._v("Download Files")]) : _vm._e()]) : _c('div', {
    staticClass: "design-options p-10 p-b-0 m-b-20 primarybg"
  }, [_c('h3', [_vm._v("EDDM Route Selection")]), _vm._v(" "), _c('p', {
    staticClass: "right notice"
  }, [_vm._v("Notice: If you leave this page before route selection is complete, you will lose your progress.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mainSection"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInDown",
      "leave-active-class": "animated fadeOutUp"
    }
  }, [(_vm.showFullService) ? _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "position": "absolute",
      "left": "10px",
      "right": "10px",
      "width": "auto",
      "z-index": "10"
    }
  }, [_c('EddmMap', {
    attrs: {
      "accessToken": _vm.eddm_token,
      "colorspec": _vm.selected.colorspec,
      "date": _vm._f("moment")(_vm.selected.date, 'YYYY-MM-DD'),
      "runsize": _vm.selected.product.detail.data[0].runsize_uuid,
      "product": _vm.selected.product.id
    },
    on: {
      "saveEddmData": _vm.saveEddmData
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 design-preview"
  }, [_c('FilePreview', {
    ref: "preview"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 order-options"
  }, [(!_vm.downloadOnly) ? _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion-group-1"
    }
  }, [_c('div', {
    staticClass: "panel panel-default prod-approval panel-1 active"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.setActivePanel('.panel-1', $event)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseOne-1",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('FileApproval', {
    on: {
      "next": _vm.nextAccordion,
      "preview": _vm.setPreview
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default prod-options panel-2"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.setActivePanel('.panel-2', $event)
      }
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-1",
      "href": "#collapseTwo-2",
      "aria-expanded": "false"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.selected.product) ? 'Product:' : 'Product Options'))]), _vm._v(" " + _vm._s((_vm.selected.product) ? _vm.selected.product.description : '') + "\n                                    "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.selected.product_cost !== null && !this.$store.state.template.eddm_only) ? _c('span', {
    staticClass: "right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('product')))]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "height": "0px"
    },
    attrs: {
      "id": "collapseTwo-2",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.products.length < 1) ? _c('p', {
    staticClass: "m-t-10"
  }, [_c('center', [_c('FulfillingBouncingCircleSpinner', {
    attrs: {
      "animation-duration": 2500,
      "size": 45,
      "color": '#232F4B'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('ProductSelector', {
    attrs: {
      "products": _vm.products,
      "selected": _vm.selected,
      "eddmDates": _vm.eddm_dates,
      "button": (_vm.$store.state.template.eddm_only) ? 'Select EDDM Routes' : 'Select Shipping Options'
    },
    on: {
      "updateSelected": _vm.updateSelected,
      "next": _vm.nextAccordion
    }
  })], 1)])]), _vm._v(" "), (!this.$store.state.template.eddm_only) ? _c('div', {
    staticClass: "panel panel-default prod-shipping panel-3"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.setActivePanel('.panel-3', $event)
      }
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-1",
      "href": "#collapseThree-3",
      "aria-expanded": "false"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.selected.method) ? 'Shipping:' : 'Shipping & Turnaround'))]), _vm._v(" " + _vm._s((_vm.selected.method) ? _vm.selected.method.service_name : '') + "\n                                    "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.selected.method || _vm.selected.turnaround) ? _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s((_vm.selected.method && _vm.selected.method.group_with_cart) ? 'Calculated In Cart' : '$' + _vm.calculateCost('shipping')))]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "height": "0px"
    },
    attrs: {
      "id": "collapseThree-3",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ShippingSelector', {
    ref: "shipping",
    attrs: {
      "products": _vm.products,
      "selected": _vm.selected,
      "button": "Continue to Summary"
    },
    on: {
      "updateSelected": _vm.updateSelected,
      "next": _vm.nextAccordion
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default prod-summary panel-4"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.setActivePanel('.panel-4', $event)
      }
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-1",
      "href": "#collapseFour-4",
      "aria-expanded": "false"
    }
  }, [_c('span', [_vm._v("Quick Summary")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.calculateCost() > 0 && !this.$store.state.template.eddm_only) ? _c('span', {
    staticClass: "right"
  }, [_vm._v("Total: $" + _vm._s(_vm.calculateCost()))]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "height": "0px"
    },
    attrs: {
      "id": "collapseFour-4",
      "aria-expanded": "false"
    }
  }, [(!this.$store.state.template.eddm_only) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "group row m-b-0 "
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "m-t-5"
  }, [_c('h4', {
    staticClass: "m-t-0 m-b-0"
  }, [_vm._v(_vm._s((_vm.selected.product) ? _vm.selected.product.description : ''))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Order Date: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(new Date(), "MM/DD/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Subtotal: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('product')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Quantity: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.selected.runsizeDescription))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_c('span', {
    staticClass: "shipping-type"
  }, [_vm._v("Shipping:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s((_vm.selected.method && _vm.selected.method.group_with_cart) ? 'Calculated In Cart' : '$' + _vm.calculateCost('shipping')))])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Total: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost()))]), _c('br'), _c('small', [_vm._v("(not including tax)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0 "
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.imagesProcessing.length > 0) ? _c('button', {
    staticClass: "btn btn-warning pull-right",
    on: {
      "click": function($event) {
        _vm.stillProcessing()
      }
    }
  }, [_vm._v("Finishing up files, please wait..")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.addToCart()
      }
    }
  }, [_vm._v("Add to Cart")])])])]) : (_vm.eddmData !== null) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "group row m-b-0"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "m-t-5"
  }, [_c('h4', {
    staticClass: "m-t-0 m-b-0"
  }, [_vm._v(_vm._s((_vm.selected.product) ? _vm.selected.product.description : ''))])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Residential: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.eddmData.map_event_data.tot_res))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Routes: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.eddmData.map_event_data.tot_sel))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Business: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.eddmData.map_event_data.tot_bus))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Total: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.eddmData.map_event_data.tot_cnt))])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0 "
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Order Date: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(new Date(), "MM/DD/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Product Cost: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('product')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Delivery Date: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.selected.date, "MM/DD/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("EDDM Service Cost: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('eddm_service')))])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Postage Cost: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('shipping')))])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Total: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost()))]), _c('br'), _c('small', [_vm._v("(not including tax)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0 "
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.imagesProcessing.length > 0) ? _c('button', {
    staticClass: "btn btn-warning pull-right",
    on: {
      "click": function($event) {
        _vm.stillProcessing()
      }
    }
  }, [_vm._v("Finishing up files, please wait..")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.addToCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.cartButtonText))])])])]) : _vm._e()])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOutRight"
    }
  }, _vm._l((_vm.imagesProcessing), function(item) {
    return (_vm.imagesProcessing.length > 0) ? _c('div', {
      key: item,
      staticClass: "panel panel-success m-t-5"
    }, [_c('div', {
      staticClass: "panel-heading p-l-10"
    }, [_c('h4', {
      staticClass: "panel-title"
    }, [_c('span', {
      staticClass: "left m-r-10 m-t-5"
    }, [_c('SpringSpinner', {
      attrs: {
        "animation-duration": 2000,
        "size": 14,
        "color": '#3C736D'
      }
    })], 1), _vm._v("\n                                    Processing " + _vm._s(item) + " file..\n                                ")])])]) : _vm._e()
  }), 0)], 1)]) : _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion-group-2"
    }
  }, [_c('div', {
    staticClass: "panel panel-default panel-1 active"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseOne-2",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("\n                                    This template does not yet have any products assigned to it."), _c('br'), _c('br'), _vm._v("\n                                    You can download the print ready files below:"), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-success solid m-b-10 primaryborder animated pulse m-t-20 m-b-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadFiles()
      }
    }
  }, [_vm._v("Download Files")])])])])])])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-1",
      "href": "#collapseOne-1",
      "aria-expanded": "true"
    }
  }, [_c('span', [_vm._v("File Approval")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "m-t-5"
  }, [_c('h4', {
    staticClass: "m-t-0 m-b-0"
  }, [_vm._v("Product:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group row m-b-0 "
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticClass: "m-b-10",
    staticStyle: {
      "width": "100%",
      "height": "1px",
      "background": "#fdfdfd"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Sets: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "m-t-5"
  }, [_c('h4', {
    staticClass: "m-t-0 m-b-0"
  }, [_vm._v("Full Service EDDM:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticClass: "m-b-10",
    staticStyle: {
      "width": "100%",
      "height": "1px",
      "background": "#fdfdfd"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12 m-t-20"
  }, [_c('h4', [_vm._v("Product Information:")]), _vm._v(" "), _c('hr', {
    staticClass: "m-b-10",
    staticStyle: {
      "width": "100%",
      "height": "1px",
      "background": "#fdfdfd"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Sets: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-2",
      "href": "#collapseOne-2",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                                    Download Files\n                                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a601bb88","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TemplateOptions.vue
// module id = 358
// module chunks = 0